import { useId } from 'react';
import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const BrowserStackColor = forwardRef<IconProps, 'svg'>((props, ref) => {
  const id = useId();
  return (
    <Icon ref={ref} viewBox="0 0 16 16" {...props}>
      <path
        d="M8.01626 15C11.8733 15 15 11.8733 15 8.01626C15 4.15924 11.8733 1.03252 8.01626 1.03252C4.15924 1.03252 1.03252 4.15924 1.03252 8.01626C1.03252 11.8733 4.15924 15 8.01626 15Z"
        fill="#F4B960"
      />
      <path
        d="M7.30806 13.6161C10.7919 13.6161 13.6161 10.7919 13.6161 7.30806C13.6161 3.82422 10.7919 1 7.30806 1C3.82422 1 1 3.82422 1 7.30806C1 10.7919 3.82422 13.6161 7.30806 13.6161Z"
        fill="#E66F32"
      />
      <path
        d="M8.17689 11.9747C11.1985 11.9747 13.648 9.52523 13.648 6.50362C13.648 3.48201 11.1985 1.03252 8.17689 1.03252C5.15528 1.03252 2.70578 3.48201 2.70578 6.50362C2.70578 9.52523 5.15528 11.9747 8.17689 11.9747Z"
        fill="#E43C41"
      />
      <path
        d="M8.59504 11.9422C11.3678 11.9422 13.6155 9.69449 13.6155 6.92178C13.6155 4.14906 11.3678 1.90134 8.59504 1.90134C5.82233 1.90134 3.5746 4.14906 3.5746 6.92178C3.5746 9.69449 5.82233 11.9422 8.59504 11.9422Z"
        fill="#BDD041"
      />
      <path
        d="M8.24127 11.9747C10.8186 11.9747 12.9079 9.8854 12.9079 7.30807C12.9079 4.73074 10.8186 2.6414 8.24127 2.6414C5.66394 2.6414 3.5746 4.73074 3.5746 7.30807C3.5746 9.8854 5.66394 11.9747 8.24127 11.9747Z"
        fill="#6DB54C"
      />
      <path
        d="M7.50121 10.4296C9.65186 10.4296 11.3953 8.68614 11.3953 6.53549C11.3953 4.38484 9.65186 2.6414 7.50121 2.6414C5.35056 2.6414 3.60712 4.38484 3.60712 6.53549C3.60712 8.68614 5.35056 10.4296 7.50121 10.4296Z"
        fill="#AEDAE6"
      />
      <path
        d="M8.1125 9.17447C9.92554 9.17447 11.3953 7.70471 11.3953 5.89168C11.3953 4.07864 9.92554 2.60888 8.1125 2.60888C6.29947 2.60888 4.82971 4.07864 4.82971 5.89168C4.82971 7.70471 6.29947 9.17447 8.1125 9.17447Z"
        fill="#56B8DE"
      />
      <path
        d="M8.53066 9.20699C10.1128 9.20699 11.3953 7.92444 11.3953 6.34235C11.3953 4.76025 10.1128 3.4777 8.53066 3.4777C6.94856 3.4777 5.66602 4.76025 5.66602 6.34235C5.66602 7.92444 6.94856 9.20699 8.53066 9.20699Z"
        fill="#00B1D5"
      />
      <path
        d="M8.1125 9.17447C9.4633 9.17447 10.5583 8.07943 10.5583 6.72863C10.5583 5.37783 9.4633 4.28279 8.1125 4.28279C6.76171 4.28279 5.66667 5.37783 5.66667 6.72863C5.66667 8.07943 6.76171 9.17447 8.1125 9.17447Z"
        fill={`url(#gradient_${id})`}
      />
      <path
        d="M8.1125 9.17447C9.4633 9.17447 10.5583 8.07943 10.5583 6.72863C10.5583 5.37783 9.4633 4.28279 8.1125 4.28279C6.76171 4.28279 5.66667 5.37783 5.66667 6.72863C5.66667 8.07943 6.76171 9.17447 8.1125 9.17447Z"
        fill="#221F1F"
      />
      <path
        d="M9.53232 6.04208C9.707 5.65279 9.65149 5.24876 9.40835 5.13966C9.16521 5.03057 8.82651 5.25771 8.65183 5.64699C8.47715 6.03628 8.53266 6.4403 8.7758 6.5494C9.01894 6.6585 9.35765 6.43136 9.53232 6.04208Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id={`gradient_${id}`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8.01112 8.09246) scale(7.05647)"
        >
          <stop stopColor="#797979" />
          <stop offset="1" stopColor="#4C4C4C" />
        </radialGradient>
      </defs>
    </Icon>
  );
});

export default BrowserStackColor;
